import { defineInlineEdit } from "../../../../components/MobileList/inlineEdit";

/** The keys views/settings/from renders as a Switch instead of a number. */
const SWITCH_KEYS = [
  "withdraw_by_rep_enabled",
  "is_default_payment_fees",
  "active_e_payment",
];

/**
 * views/settings/from PUTs `{value, note}` only, and the list row carries both,
 * so no detail fetch is needed — which is just as well: the settings endpoint
 * has no getById.
 *
 * `key` is the setting's identifier and is not part of the form.
 */
export default defineInlineEdit({
  api: "settings",
  hydrate: false,
  toPayload: (source) => ({
    value: source.value,
    note: source.note ?? "",
  }),
  fields: {
    value: {
      label: "القيمة",
      // Same per-setting branch the dialog makes.
      type: (row) => (SWITCH_KEYS.includes(row?.key) ? "boolean" : "number"),
      required: true,
      validate: (value, row) => {
        if (row?.key !== "withdraw_by_rep_enabled") return null;
        const numeric = Number(value);
        return numeric === 0 || numeric === 1
          ? null
          : "القيمة يجب أن تكون 0 أو 1 فقط";
      },
    },
    note: { label: "الملاحظة", type: "text" },
  },
});
